import React from 'react'

export const Adjust = () =>
  <svg stroke='currentColor' fill='currentColor' strokeWidth='0' viewBox='0 0 16 11' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg'>
    <path d='M9.62.77A.77.77,0,0,0,8.85,0H.77a.77.77,0,1,0,0,1.53H8.85A.77.77,0,0,0,9.62.77Zm3.19,9.09V7.6h2.44a.75.75,0,0,0,0-1.5H12.81V3.84a.81.81,0,0,0-1.62,0V6.1H8.75a.75.75,0,0,0,0,1.5h2.44V9.86a.81.81,0,0,0,1.62,0ZM9.62,3.8A.78.78,0,0,0,8.85,3H.77a.77.77,0,0,0,0,1.54H8.85A.78.78,0,0,0,9.62,3.8ZM6.38,6.85a.75.75,0,0,0-.74-.75H.75a.75.75,0,0,0,0,1.5H5.64A.75.75,0,0,0,6.38,6.85Z' />
  </svg>
